/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOperation} from '../api'

 export const useQueryGetOperation = createReactQueryHook('getOperation', getOperation)
